<template>
  <div
    class="result-details w-100 position-relative"
    :class="{ 'pre-loader': isLoading }"
  >
    <transition-group name="fade">
      <div
        v-if="emptyData && !isLoading && !editMode"
        class="d-flex align-items-center h-100 justify-content-around m-2"
      >
        {{
          $t(
            '_web_match_results_data-not-found',
            'Battle results data not found'
          )
        }}
      </div>
      <div
        v-else-if="!battle.battle_id"
        class="d-flex align-items-center h-100 justify-content-around m-2 hera-muted"
      >
        {{ $t('_web_match_results_battle-not-found', 'Battle ID not found') }}
      </div>
      <!-- Content results-->
      <template v-else-if="!isLoading">
        <template v-for="(round, index) in roundsCount">
          <div
            :key="`round-${index}-results`"
            class="d-flex justify-content-center align-items-center flex-nowrap mx-0 mb-4 results-row"
          >
            <div
              class="d-flex align-items-center justify-content-end results-left w-100"
            >
              <Attachments
                :key="index"
                v-model="playerOne.results[index]"
                class="d-flex align-items-center flex-row-reverse"
                :match-id="battle.id"
              />
              <TextBlock
                v-if="isRoundConflicted(index)"
                :size="0.75"
                class="mx-3"
                variant="secondary"
                >{{ playerOne.results[index].player_1_scored }}&nbsp;:&nbsp;{{
                  playerOne.results[index].player_2_scored
                }}</TextBlock
              >
            </div>

            <div
              class="scores-column d-flex justify-content-between align-items-center mx-3"
              :class="{
                disabled: !editMode,
              }"
            >
              <Scores
                :value="
                  playerOne.results[index].player_1_scored ||
                    playerTwo.results[index].player_1_scored
                "
                :edit-mode="editMode"
                :has-errors="isRoundConflicted(index)"
                @update="setScores($event, 1, index)"
              />
              <div class="scores-separator text-center mx-3">
                <Icon
                  v-if="isRoundConflicted(index)"
                  name="scales"
                  :fill="$scss.colors.secondaryTextBg"
                />
                <template v-else
                  >:</template
                >
              </div>
              <Scores
                :value="
                  playerOne.results[index].player_2_scored ||
                    playerTwo.results[index].player_2_scored
                "
                :edit-mode="editMode"
                :has-errors="isRoundConflicted(index)"
                @update="setScores($event, 2, index)"
              />
            </div>
            <div
              class="d-flex align-items-center justify-content-start results-right w-100"
            >
              <TextBlock
                v-if="isRoundConflicted(index)"
                :size="0.75"
                variant="secondary"
                class="mx-3"
                >{{ playerTwo.results[index].player_1_scored }}&nbsp;:&nbsp;{{
                  playerTwo.results[index].player_2_scored
                }}</TextBlock
              >
              <Attachments
                :key="index"
                v-model="playerTwo.results[index]"
                class="d-flex align-items-center justify-content-start"
                :match-id="battle.id"
              />
            </div>
          </div>
        </template>
      </template>
    </transition-group>
  </div>
</template>

<script>
// TODO TH-7387 Completely rework this component!!!

import { mapActions, mapMutations } from 'vuex';
// import Avatar from '@/components/common/avatar.vue';
import Scores from '@/components/tournaments/SingleScore.vue';
import TextBlock from '@/components/atoms/TextBlock';
import Attachments from '@/components/tournaments/MatchAttachments.vue';
import Icon from '@/components/atoms/Icon';
import { cloneDeep, isNumber } from '@/utils/lodashUtils';

//mocks
//import mock  from '@/__mock__/matches.js'
export default {
  name: 'MatchResults',
  components: {
    Icon,
    Scores,
    Attachments,
    TextBlock,
  },
  props: {
    battle: {
      type: Object,
      default: () => ({}),
    },
    isMatchConflicted: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      backupResult: {},
      battleResult: {
        player_1_match_results: [],
        player_2_match_results: [],
      },
      isLoading: true,
    };
  },
  computed: {
    playerOne() {
      const player =
        this.$lodash.get(this, 'battle.player_1') ||
        this.$lodash.get(this, 'battle.players[0].profile') ||
        {};
      return {
        results: this.battleResult.player_1_match_results,
        ...player,
        avatarUrl: player.avatar || player.logo || null,
        // name: player.login || player.name,
        // type: player.type,
      };
    },
    playerTwo() {
      const player =
        this.$lodash.get(this, 'battle.player_2') ||
        this.$lodash.get(this, 'battle.players[1].profile') ||
        {};
      return {
        results: this.battleResult.player_2_match_results,
        ...player,
        avatarUrl: player.avatar || player.logo || null,
        // name: player.login || player.name,
        // type: player.type,
      };
    },
    roundsCount() {
      return +(
        this.battle.number_of_rounds ||
        this.battle.number_of_matches ||
        1
      );
    },
    emptyData() {
      return !this.playerOne.results.length && !this.playerTwo.results.length;
    },
  },
  watch: {
    editMode() {
      // reset entered results in view mode
      this.battleResult = this.backupResult;
    },
  },
  created() {
    this.getBattleResults({
      battleID: this.battle.battle_id,
      rounds: this.battle.number_of_rounds || this.battle.number_of_matches,
    })
      .then(result => {
        this.battleResult = {
          ...cloneDeep(result),
          ...(cloneDeep(result.match_results) || null),
        };

        const battleSort = (battle1, battle2) => {
          return battle1.round - battle2.round;
        };
        this.battleResult.player_1_match_results.sort(battleSort);
        this.battleResult.player_2_match_results.sort(battleSort);

        this.setBackup();
        this.isLoading = false;
        //init
        this.initTempMatchResults({
          battle_id: this.battle.battle_id,
          player_1: this.battleResult.player_1_match_results,
          player_2: this.battleResult.player_2_match_results,
        });
      })
      .catch(this.errorNotify);
  },
  methods: {
    ...mapMutations(['setTempMatchResults', 'initTempMatchResults']),
    ...mapActions(['getBattleResults', 'errorNotify']),
    isRoundConflicted(index) {
      return (
        this.playerOne.results[index].player_1_scored !==
          this.playerTwo.results[index].player_1_scored ||
        this.playerOne.results[index].player_2_scored !==
          this.playerTwo.results[index].player_2_scored
      );
    },
    setScores(score, playerIndex, roundIndex) {
      //admin can set only equal results

      // const { round, player_1_scored, player_2_scored } = scores;

      const player1Results = this.battleResult.player_1_match_results[
        roundIndex
      ];
      const player2Results = this.battleResult.player_2_match_results[
        roundIndex
      ];
      player1Results[`player_${playerIndex}_scored`] = score;
      // player1Results.player_2_scored = player_2_scored;
      player2Results[`player_${playerIndex}_scored`] = score;
      // player2Results.player_2_scored = player_2_scored;

      if (isNumber(score)) {
        //set results temp for match round
        this.setTempMatchResults({
          player_1: player1Results,
          player_2: player2Results,
          round: roundIndex,
          battle_id: this.battle.battle_id,
        });
      }
    },
    setBackup() {
      this.backupResult = cloneDeep(this.battleResult);
    },
  },
};
</script>

<style lang="scss" scoped>
.result-details {
  min-height: 30px;
  // position: relative;

  &.pre-loader {
    &:before {
      top: 0rem;
    }
  }
  .clan-owner {
    cursor: pointer;
    color: $ph-accent;
  }

  .card-labels {
    font-size: 0.75rem;
    color: $ph-secondary-text;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .round-names {
    max-width: 4rem;
  }
  .results-left,
  .results-right {
    max-width: calc(50% - 45px);
  }
  .scores-column {
    flex-basis: 90px;
    .scores-separator {
      width: 1.5rem;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.1s;
  }
}

.lh-30 {
  line-height: 30px;
}
</style>
